var _rect, _path, _mask, _g, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimerControlBase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 440,
    viewBox: "0 0 400 440",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 25.3828,
    width: 400,
    height: 414.615,
    rx: 10,
    fill: "#CCCCCC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47716 4.47715 0 10 0H390C395.523 0 400 4.47715 400 10V426C400 431.523 395.523 436 390 436H9.99999C4.47714 436 0 431.523 0 426V10Z",
    fill: "white"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 32,
    y: 56,
    width: 336,
    height: 131
  }, /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 56,
    width: 336,
    height: 131,
    rx: 1,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M368 56H32V187H368V56Z",
    fill: "#003F52"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 368,
    y: 187,
    width: 336,
    height: 8.00019,
    transform: "rotate(180 368 187)",
    fill: "#002B39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368 56L368 187L360 187L360 61.24L368 56Z",
    fill: "#002B39"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M214.357 56L105 179H217.487L328 56H214.357Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M351.089 56L246.5 179H268.867L368 56H351.089Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M352 39.9974H48C48 39.9974 135.422 24.6191 192 23.9974C254.792 23.3074 352 39.9974 352 39.9974Z",
    fill: "#F2F2F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimerControlBase);
export default __webpack_public_path__ + "static/media/timer_control_base.3c176743305521e320de63a9e0ad299f.svg";
export { ForwardRef as ReactComponent };